import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IAppSelectionPayload, IAppSelectionResponse } from "../../interfaces";

export const useUpdateAppSelection = () => {
  const queryClient = useQueryClient();

  return useMutation<IAppSelectionResponse, Error, IAppSelectionPayload>({
    mutationFn: async (payload) => {
      return httpService.patch<IAppSelectionResponse, IAppSelectionPayload>(
        API_CONFIG.path.integrationAppsSelection,
        payload
      );
    },
    onSuccess: (_, { tracking_id }) => {
      queryClient.invalidateQueries({
        queryKey: ["integration-apps", tracking_id ?? "all"],
      });
    },
  });
};
